import React, {useState, useEffect, useRef} from 'react';
import { useParams } from "react-router";
import { useHistory } from 'react-router-dom';
import routes from 'globals/routes';

import { useDataValue } from 'globals/contexts/dataContext';

import scrollingTo from 'utils/scrollingTo';
import ProjectWrapper from 'components/projectWrapper';

import './projectListSection.css';

const ProjectListSection = (props) => {
  const pageContent = props['content'];
  // https://dev.to/finallynero/hooks-introduced-in-react-router-v5-1-7g8
  const { filter: presetFilter = null } = useParams();
  const [selectedFilter, setSelectedFilter] = useState(presetFilter);
  const [{currentPage, currentLanguage}] = useDataValue();
  const filterWrapper = useRef();
  const history = useHistory();
  useEffect(() => {
    if (selectedFilter) {
      scrollingTo(filterWrapper.current);
    }
  }, [selectedFilter])
  return <section className="projectList" id="projectList">
    {pageContent['mediaurl'] && <div className="iframeWrapper">
      <iframe src={pageContent['mediaurl']} />
    </div>}
    <ProjectWrapper items={pageContent['gallery']} selectedFilter={selectedFilter} 
      colOffestTop={[0, 100]}
      ProjectInfoRenderer = {({project}) => {
        return (project['caption'] ? 
          <div className="projectInfo">
            <div className="caption">{project['caption']}</div>
          </div>
          :
          null
        );
      }} />
  </section>;
}

export default ProjectListSection;